import { render, staticRenderFns } from "./ArchivedVehicles.vue?vue&type=template&id=1fe68271&"
import script from "./ArchivedVehicles.vue?vue&type=script&lang=ts&"
export * from "./ArchivedVehicles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports